import React, { Component, Fragment } from 'react';
import Stepper from '../../shared/Stepper';
import { Route } from 'react-router-dom';
import ActivityIndicator from '../../shared/ActivityIndicator';
import InsuranceErrors from './InsuranceErrors';
import {
  generateRoutes,
  getSteps,
  getOptionals,
  getRoutes,
  goBack
} from '../../../helpers/stepperFunctions';
import { clearCache } from '../../../actions/insurance_actions';

class Insurance extends Component {
  state = {
    persisted: false,
    routeList: []
  };

  async componentDidMount() {
    const process = 'insurance';
    this.checkIfComingFromProcess(process);
    if (this.props.location.pathname.includes('validate-contract')) {
      await this.props.resetStepper();
      this.tryGetProcessAndSetRoutes(process);
    } else {
      this.props.persistInsurance();
      this.props.persistStepper();
    }
  }

  checkIfComingFromProcess(process) {
    const state = this.props.location.state;
    if (state.from) {
      const routeList = generateRoutes(process, {});
      let diffProcess = true;
      routeList.forEach(value => {
        if (value.path == state.from) diffProcess = false;
      });
      if (diffProcess) {
        this.props.clearInsuranceStore();
        clearCache();
      }
    }
  }

  componentDidUpdate = () => {
    if (
      !this.state.persisted &&
      !this.props.location.pathname.includes('validate-contract')
    ) {
      this.tryGetProcessAndSetRoutes(this.props.process);
    }
  };

  tryGetProcessAndSetRoutes = process => {
    if (process) {
      const routeList = generateRoutes(process, {});
      this.props.setSteps(getSteps(routeList), getRoutes(routeList), process);
      this.setState({ routeList, persisted: true });
    }
  };

  _renderStep = () => {
    const { location } = this.props;
    const currentStep = this.props.routes.indexOf(location.pathname);
    const maxStep = this.props[`${this.props.process}Next`];
    const route = this.state.routeList.find(
      route => route.path === location.pathname
    );
    if (currentStep >= 0 && maxStep >= 0 && route) {
      if (currentStep <= maxStep) {
        return (
          <Fragment>
            <Stepper />
            <Route exact path={route.path} component={route.component} />
          </Fragment>
        );
      } else {
        this.props.history.push(this.props.routes[maxStep]);
        this.props.newAlert(
          'error',
          'ERROR:',
          'No puedes ingresar a este paso sin haber completado los anteriores.'
        );
      }
    } else {
      this.props.history.push(this.props.routes[maxStep]);
      this.props.newAlert(
        'error',
        'ERROR:',
        'La ruta ingresada no existe en el registro de servicios.'
      );
    }
  };

  render() {
    const {
      location,
      server_errors,
      baseErrorOpen,
      baseErrorText,
      baseErrorTitle,
      baseErrorRoute,
      toggleBaseErrorModal,
      loadingParameters
    } = this.props;
    if (loadingParameters && location.pathname.includes('validate-contract'))
      return <ActivityIndicator />;
    if (!this.state.persisted) return null;
    return (
      <Fragment>
        <InsuranceErrors
          server_errors={server_errors}
          baseErrorOpen={baseErrorOpen}
          baseErrorText={baseErrorText}
          baseErrorTitle={baseErrorTitle}
          toggleModal={toggleBaseErrorModal}
          baseErrorRoute={baseErrorRoute}
        />
        {this._renderStep()}
      </Fragment>
    );
  }
}

export default Insurance;
